import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export interface PdfReportDTO {
  fileName: string;
  tableElement: HTMLElement; // referencia a la tabla
  orientation?: 'p' | 'l';   // portrait o landscape
}


export async function pdfGenerator(dto: PdfReportDTO) {
  const { fileName, tableElement, orientation = 'p' } = dto;

  // Capturar la tabla como imagen
  const canvas = await html2canvas(tableElement, {
    scale: 3, // mayor calidad
    useCORS: true
  });

  const imgData = canvas.toDataURL('image/png');

  const pdf = new jsPDF({
    orientation,
    unit: 'pt',
    format: 'a4'
  });

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = pdfWidth - 40; // margen lateral
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let position = 20;

  // Si la tabla no cabe en una sola página, dividirla
  if (imgHeight < pdfHeight) {
    pdf.addImage(imgData, 'PNG', 20, position, imgWidth, imgHeight);
  } else {
    let heightLeft = imgHeight;

    while (heightLeft > 0) {
      pdf.addImage(imgData, 'PNG', 20, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
      if (heightLeft > 0) pdf.addPage();
    }
  }

  pdf.save(`${fileName}.pdf`);
}
